import React, { Suspense } from 'react';
import styled from 'styled-components';
import { Modal as ShellModal } from '@sede-enterprise/shell-ds-react-framework';

interface SuspenseLoadPageProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const Modal = styled(ShellModal)`
  .shell-modal-container-content {
    min-height: 150px !important;
  }
  .shell-modal-container-body {
    width: 100%;
  }
`;

const SuspenseLoadPage: React.FC<SuspenseLoadPageProps> = ({
  children,
  fallback,
}) => {
  const renderFallBack = () =>
    fallback ?? (
      <Modal
        open
        onClose={() => {}}
        loading
        loadingBody={<>Loading...</>}
        closable={false}
        maskClosable={false}
        width={200}
        centered
      />
    );

  return <Suspense fallback={renderFallBack()}>{children}</Suspense>;
};

export default SuspenseLoadPage;
